// extracted by mini-css-extract-plugin
module.exports = {"icon":"MembershipBlock_icon__x_sDp","iconGray":"MembershipBlock_iconGray__yL50m","iconOrange":"MembershipBlock_iconOrange__yG0mN","innerTitle":"MembershipBlock_innerTitle__u61Y8"};